import { cn } from '@app/utils/cn';
import React, { WithChildren } from 'react';

interface Props {
  ariaLabel?: string;
  onClick?: () => void;
  disabled?: boolean;
  isActive?: boolean;
}

export const Pager = React.forwardRef<HTMLLIElement, WithChildren<Props>>((props, ref) => {
  const { ariaLabel = '', children, onClick, disabled, isActive } = props;

  return (
    <li
      ref={ref}
      className={cn('mr-1 flex h-9 w-8 justify-center rounded-regular bg-transparent text-neutral-40 transition-all duration-300 md:mx-1', {
        'bg-white text-neutral-20': isActive,
        'hover:bg-neutral-98 has-[:focus-visible]:bg-neutral-98': !disabled && !isActive,
      })}
    >
      <button
        aria-label={ariaLabel}
        onClick={onClick}
        disabled={disabled}
        className={cn('group relative flex w-full items-center justify-center rounded-regular has-[:focus-visible]:focus-input-outline', {
          'cursor-not-allowed text-neutral-20': disabled,
        })}
      >
        {children}
      </button>
    </li>
  );
});
